module.exports = __webpack_public_path__ + "img/mailIcon.41b3bd2b.svg";